import styled from 'styled-components';
import DefaultContentRenderer from 'components/generic/Drawer/components/DefaultContentRenderer';
import DrawerView from 'components/generic/Drawer/DrawerView';
import useDrawer, {} from 'components/generic/Drawer/hooks/useDrawer';
import Flex from 'components/Layout/components/Flex';
import ChatAgentOptionRenderer from './components/ChatAgentOptionRenderer';
import ChatButton from './components/ChatButton';
import ChatHeaderRenderer from './components/ChatHeaderRenderer';

export const CHAT_ENTRY_DRAWER_ID = 'drawer-view-chat' as const;

const Content = styled(Flex.Column)`
    padding: ${({ theme }) => theme.Spacing20} ${({ theme }) => theme.Spacing16};
    gap: ${({ theme }) => theme.Spacing16};
`;

const ChatEntry: React.FC = () => {
    const { open: openDrawer, isOpen: isDrawerOpen } = useDrawer(CHAT_ENTRY_DRAWER_ID, { disableOverlay: true });

    return (
        <>
            <DrawerView
                id={CHAT_ENTRY_DRAWER_ID}
                position="right"
                fullscreen
                headerRenderer={(props) => <ChatHeaderRenderer {...props} />}
                contentRenderer={(props) => <DefaultContentRenderer.NoPadding {...props} />}
            >
                <Content>
                    <ChatAgentOptionRenderer options={['comai', 'customersupport']} />
                </Content>
            </DrawerView>
            <ChatButton toggleChat={openDrawer} chatOpen={isDrawerOpen} />
        </>
    );
};

export default ChatEntry;
